import React, { useContext } from 'react';
import button_arrow_right from 'images/button_arrow_right.svg';
import { AppContext } from 'context/AppContext';

const SmallAside = (props) => {
    let appContext = useContext(AppContext);

    const handleAsideVisible = () => {
        appContext.setAsideIsVisible(!appContext.asideIsVisible);
    };

    return (
        <>
            <div className="small-aside">
                <img
                    className="button-arrow-right-nav"
                    onClick={handleAsideVisible}
                    src={button_arrow_right}
                    style={{ position: 'absolute', top: '50%', right: '-7px' }}
                />
            </div>
        </>
    );
};

export default SmallAside;
